import NavigationView 	from '@/components/NavigationView'
import TabView 			from '@/components/TabView'
import TableView 		from '@/components/TableView'
import ButtonView 		from '@/components/ButtonView'
import StringView 		from '@/components/StringView'
import ModalView 		from '@/components/ModalView'
import SelectView 		from '@/components/SelectView'
import SliderView 		from '@/components/SliderView'
import MovableView 		from '@/components/MovableView'
import SliderSelectView from '@/components/SliderSelectView'
import PopupView 		from '@/components/PopupView'
import SelectPopupView 	from '@/components/SelectPopupView'
import InputView 		from '@/components/InputView'
import TextView 		from '@/components/TextView'
import DateView 		from '@/components/DateView'
import HeaderFragment	from '@/app/fragments/HeaderFragment'
import MonthView		from '@/components/MonthView'
import FileOverlay		from '@/components/FileOverlay'
import CameraOverlay	from '@/components/CameraOverlay'

export default [
	NavigationView,
	TabView,
	ButtonView,
	TableView,
	StringView,
	ModalView,
	SelectView,
	SliderView,
	MovableView,
	SliderSelectView,
	PopupView,
	InputView,
	TextView,
	HeaderFragment,
	SelectPopupView,
	DateView,
	MonthView,
	FileOverlay,
	CameraOverlay
];